module.exports = __webpack_public_path__ + "f18278bb8b77c8c6136064565059d582.jpg";